import {GetSeferData} from "SeferPetach/GetData";

export async function getCompanyPositionList() {
    var args = {};
    var payload = await GetSeferData("cpf1", args);
    return (payload);
}

export async function getCompanyPositionByID(company_position_id){
    var args = {
        'COMPANY_POSITION_ID': company_position_id
    };
    var payload = await GetSeferData("cpf2", args);
    return (payload);
}

export async function updateCompanyPosition(obj) {
    var args = obj;
    var payload = await GetSeferData("cpf3", args);
    return (payload);
}

export async function deleteCompanyPosition(company_position_id){
    var args = {
        'COMPANY_POSITION_ID': company_position_id
    };
    var payload = await GetSeferData("cpf4", args);
    return (payload);
}